<template>
  <div id="grid-action-bar">
    <div class="vx-row w-full m-0">
      <div class="vx-col w-full action-bar-wrapper">
        <div class="flex flex-row flex-no-wrap justify-end top-row py-2">
          <div class="title-slot mr-auto flex items-center">
            <h2>{{ title }}</h2>
          </div>
          <vs-input
              class="quick-search mr-4 flex justify-end items-center"
              placeholder="Search..."
              v-if="showSearch"
              v-model="search"
          />

          <!-- ACTION - DROPDOWN -->
          <vs-dropdown v-if="$slots.default" class="cursor-pointer" vs-trigger-click >

            <vs-button
                class="py-3 px-4 flex items-end justify-center content-center text-lg shadow-drop"
                color="primary">
              <span class="mr-2 leading-none actions-button">Actions</span>
              <feather-icon icon="ChevronDownIcon" svgClasses="actions-chevron h-4 w-4"/>
            </vs-button>

            <vs-dropdown-menu class="actions-dropdown">
              <slot></slot>
            </vs-dropdown-menu>
          </vs-dropdown>
          <slot name="top-right"></slot>
        </div>

        <div class="flex flex-row flex-no-wrap justify-between top-row">
            <slot name="bottom-left" class="mr-auto"></slot>
            <yes-no-toggle
                v-if="showDeleted"
                class="flex mr-4 items-end pb-3 yes-no-toggle"
                v-model="deleted"
            >
              <span class="ml-2 mr-2">Show deleted</span>
            </yes-no-toggle>
        </div>
      </div>
    </div>
  </div>

</template>

<script>
import YesNoToggle from "@/views/components/extra-components/YesNoToggle";

export default {
  name: "GridActionBar",
  components: {
      YesNoToggle,
  },
  props: {
    showSearch: {
      type: Boolean,
      default: true,
    },
    showDeleted: {
      type: Boolean,
      default: true,
    },
    title: {
      type: String,
      default: ''
    }
  },
  data() {
    return {
      search: '',
      deleted: false,
    };
  },
  watch: {
    search: {
      handler(newSearch) {
        this.$emit('update:search', newSearch);
      },
      immediate: true,
    },
    deleted(newValue) {
      this.$emit('update:deleted', newValue === true ? 1 : 0);
    }
  },
};
</script>

<style lang="scss">
  .input-span-placeholder {
    font-size: 1rem;
    top: -1px;
  }

  .toggle-button {
    border: none !important;
  }

  #grid-action-bar {
    border-bottom: 1px solid #eff1f3;

    .actions-chevron {
      position: relative;
      top: 2px;
    }

    .actions-button {
      font-size: 14px;
    }

    .action-bar-wrapper {
      .page-card-title {
        border: none;
      }

      .bottom-row {
        border-bottom: 1px solid #eff1f3;

        .yes-no-toggle {
          border-left: 1px solid #eff1f3;
          padding: 0;
        }
      }
    }

    .quick-search {
      max-width: 400px;
      font-size: 11px !important;

      > div {
        width: 100%;
      }
    }
  }
</style>
